// client/src/api/config.js
import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to include the auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // This instance sets a default 'application/json' Content-Type, but
    // that default persists even for FormData bodies (axios only strips a
    // Content-Type set directly on the request, not an instance default) —
    // so file-upload requests were being sent as JSON. Remove it here so
    // axios/the browser can set the correct multipart boundary instead.
    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;